<template>
  <BModal
    centered
    :title="dialogTitle"
    :id="dialogId"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    :cancel-variant="cancelVariant"
    :ok-only="okOnly"
    :ok-disabled="isOkDisabled"
    :no-close-on-backdrop="noCloseOnBackdrop"
    @ok.prevent="emitOkay"
    header-bg-variant="info"
    title-class="text-white"
    ok-variant="info"
  >
    <BContainer fluid class="custom-modal-container">
      <BFormRow>
        <slot></slot>
      </BFormRow>
    </BContainer>
  </BModal>
</template>
<script>
export default {
  emits: ["ok"],
  props: {
    dialogId: {
      type: String,
      required: false,
      default: "custom-update-dialog",
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    okOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    okTitle: {
      type: String,
      default: "ویرایش",
    },
    cancelTitle: {
      type: String,
      default: "بستن",
    },
    cancelVariant: {
      type: String,
      default: "",
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    isOkDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitOkay() {
      this.$emit("ok");
    },
  },
  components: {
    BModal,
    BContainer,
    BFormRow,
    BCol,
  },
};
import { BModal, BContainer, BFormRow, BCol } from "bootstrap-vue";
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  .custom-modal-container {
    max-height: 500px !important;
    overflow-y: auto;
  }
}
@media only screen and (min-width: 769px) {
  .custom-modal-container {
    max-height: 700px !important;
    overflow-y: auto;
  }
}
</style>
